import * as LayoutComponents from "ui/templates/Game/LayoutComponents";
import { motion } from "framer-motion";
import Button from "ui/atoms/Button/Button";
import { descriptionsByGame } from "shared/games/allTechniqueGameDescriptions";
import { ArrowTrendingUpIcon, TrophyIcon } from "@heroicons/react/24/solid";
import Link from "util/Link";
import GameWrapper from "ui/templates/Game/GameWrapper";
import useAuth from "util/useAuth/useAuth";
import { Props as TodosQuestionProps } from "./useTodoQuestions";

type Props = TodosQuestionProps & {
  href: string;
};

export default function EndOfRoundScreen(props: Props) {
  const auth = useAuth();

  return (
    <GameWrapper
      auth={auth}
      inGameContextTitle={
        props.type === "by-category" ? `0 remaining` : undefined
      }
    >
      <LayoutComponents.Toolbar mobileStyle={"fixed"}>
        <div className={"flex items-center justify-between"}>
          <div>
            <div className={"hidden md:block"}>
              <motion.h1
                className={"font-brik text-4xl leading-none text-emerald-500"}
                initial={{ opacity: 0, y: -10 }}
                animate={{ y: 0, opacity: 1 }}
              >
                All Done!
              </motion.h1>

              <motion.p
                className={"text-base leading-none text-white"}
                initial={{ opacity: 0, y: -10 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.1 }}
              >
                {props.type === "by-category"
                  ? "You completed this setlist!"
                  : "You are at the end of the line!"}
              </motion.p>
            </div>
          </div>

          <Button theme={"default"} size="large" as={Link} href={props.href}>
            Keep Going
          </Button>
        </div>
      </LayoutComponents.Toolbar>

      <LayoutComponents.Container>
        <Link
          className={"bg-emerald-500 rounded py-10 px-4 block"}
          href={props.href}
        >
          <div className={"flex items-center justify-center text-center"}>
            <div
              className={
                "text-4xl font-brik mb-4 bg-emerald-700 h-40 w-40 rounded-full flex items-center justify-center"
              }
            >
              {props.type === "by-category" ? (
                <TrophyIcon className={"w-24 fill-emerald-400"} />
              ) : (
                <ArrowTrendingUpIcon className={"w-24 fill-emerald-400"} />
              )}
            </div>
          </div>

          <div className={"text-center mb-4 text-xl max-w-[500px] mx-auto"}>
            <Text {...props} />
          </div>
        </Link>
      </LayoutComponents.Container>
    </GameWrapper>
  );
}

function Text(props: Props) {
  if (props.type === "by-category") {
    return (
      <div>
        You completed "
        <span className={"font-bold"}>
          {props.games
            .map((game) => {
              return descriptionsByGame[game].title;
            })
            .join(", ")}
        </span>
        " in <span className={"font-bold"}>{props.difficulty}</span> mode.{" "}
        <span className={"underline underline-offset-2"}>
          Keep the streak going!
        </span>
      </div>
    );
  }

  if (props.type === "by-id") {
    return (
      <div>
        You reached the end of the line! Head back and{" "}
        <span className={"underline underline-offset-2"}>
          keep up the good work!
        </span>
      </div>
    );
  }

  return null;
}
